import React, { useEffect, useState } from "react";

import { Col, Container, FormLabel, FormSelect, Row } from "react-bootstrap";

import Title from "../../components/title";

import { baseService } from "../../services/baseServices";
import {
  colunasEstoqueQualidade,
  colunasEstoqueQualidadeCollapse,
  colunasEstoqueQualidadeCollapseInternal,
} from "../../util/tables";
import { agruparPorQualidade, converterLoja } from "../../util/loja";
import { arrayBases } from "../../util/loja";
import toast from "react-hot-toast";

import { PermissionsPage } from "../../util/permissionsPage";
import { CollapseTable } from "../../components/TableCollapse";
import FunnelChart from "../../components/Funil";

import { useCallback } from "react";
import { ContainerIniciarBusca } from "./styles";
import "./style.css";
import { useUserData } from "../../hooks/useUserData";
import { Box, Stack, Typography } from "@mui/material";
import { LoadingTable } from "../../components/Loading/LoadingTable";
import { MultiSelectFilterBases } from "../../components/FilterLojaMetas/MultiSelectFilterBases";
import { ButtonFilter } from "../../components/buttonFilter";
import Select from "react-select";
import { colourStyles } from "../vendas/vendas-global/chartConfig";

function getUniqueCodlojas(products) {
  const codlojas = products.map((product) => product.CodLoja);
  return [...new Set(codlojas)];
}

export function EstoqueQualidade() {
  const { userData } = useUserData();
  const accessLevel = userData?.nivelAcesso;
  const acessBase = userData?.baseAcesso;
  const [estoque, setEstoque] = useState([]);
  const [estoqueFormatado, setEstoqueFormatado] = useState([]);
  const [filterParams, setFilterParams] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [basesDisponiveis, setBasesDisponiveis] = useState([]);

  const [agrupamento, setAgrupamento] = useState("Grupo");
  const [tipoFunil, setTipoFunil] = useState("TotalMonetario");
  const [filtrosLojasSelecionadas, setFiltrosLojasSelecionadas] = useState([]);

  const [lojasDisponiveis, setLojasDisponiveis] = useState([]);
  const [basesSelecionadas, setBasesSelecionadas] = useState([]);

  const preencherDados = useCallback(async () => {
    //////////////////////////
    setIsLoading(true);
    const toastId = toast.loading(`Buscando dados...`);
    //////////////////////////
    let result = await baseService.getQualidade({
      bases: filterParams.bases,
    });

    if (!result) {
      toast.error(`Erro ao buscar dados`, {
        id: toastId,
      });
      return;
    }
    setEstoque(result);
    let auxCodLojas = getUniqueCodlojas(result);

    setLojasDisponiveis(auxCodLojas);

    let estoqueResult = result;
    if (filtrosLojasSelecionadas.length !== 0) {
      estoqueResult = result.filter(
        (item) => filtrosLojasSelecionadas.indexOf(item.CodLoja) >= 0
      );
    }

    result = agruparPorQualidade(estoqueResult, "Grupo", tipoFunil);

    setEstoqueFormatado(result);

    //////////////////////////
    setIsLoading(false);
    toast.success(`Dados recebidos`, {
      id: toastId,
    });
    //////////////////////////
  }, [filterParams, filtrosLojasSelecionadas, tipoFunil]);

  const filtrarBases = (bases) => {
    setBasesSelecionadas(bases);
  };

  const buscarNivelAcesso = async () => {
    if (accessLevel) {
      setBasesDisponiveis(arrayBases(acessBase));
      if (acessBase.length > 0) {
        console.log('aaaa');

        setBasesSelecionadas([acessBase[0]]);
        iniciarFiltro({ bases: [acessBase[0]] });
      }
    }
  };

  function filtrarPorLoja(lojas) {
    console.log({ lojas });

    const toastId = toast.loading(`Tratando dados...`);

    const valueLojas = lojas.map((loja) => loja.value);

    setFiltrosLojasSelecionadas(valueLojas);
    let estoqueResult = estoque;

    if (valueLojas.length !== 0) {
      estoqueResult = estoque.filter(
        (item) => valueLojas.indexOf(item.CodLoja) >= 0
      );
    }

    let result = agruparPorQualidade(estoqueResult, agrupamento, tipoFunil);
    setEstoqueFormatado(result);
    toast.success(`Dados recebidos`, {
      id: toastId,
    });
  }

  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => {
      return (
        <Container>
          <CollapseTable
            rowKey="indicador"
            dadosParaTabela={row?.agrupamento}
            colunas={colunasEstoqueQualidadeCollapse()}
            expandRow={expandRowInternal}
          />
        </Container>
      );
    },
  };

  const expandRowInternal = {
    onlyOneExpanding: true,
    renderer: (row) => {
      return (
        <Container>
          <CollapseTable
            rowKey="CodProd"
            dadosParaTabela={row?.products}
            colunas={colunasEstoqueQualidadeCollapseInternal()}
          />
        </Container>
      );
    },
  };

  function handlerFunil(value) {
    const toastId = toast.loading(`Tratando dados...`);

    setTipoFunil(value);
    let estoqueResult = estoque;
    if (filtrosLojasSelecionadas.length !== 0) {
      estoqueResult = estoque.filter(
        (item) => filtrosLojasSelecionadas.indexOf(item.CodLoja) >= 0
      );
    }
    let result = agruparPorQualidade(estoqueResult, agrupamento, value);

    setEstoqueFormatado(result);

    toast.success(`Dados recebidos`, {
      id: toastId,
    });
  }

  function handlerAgrupamento(value) {
    setAgrupamento(value);
    const toastId = toast.loading(`Tratando dados...`);

    let estoqueResult = estoque;
    if (filtrosLojasSelecionadas.length !== 0) {
      estoqueResult = estoque.filter(
        (item) => filtrosLojasSelecionadas.indexOf(item.CodLoja) >= 0
      );
    }

    let result = agruparPorQualidade(estoqueResult, value, tipoFunil);
    setEstoqueFormatado(result);

    toast.success(`Dados recebidos`, {
      id: toastId,
    });
  }

  function iniciarFiltro(defaultValue = null) {
    if (defaultValue) {
      return setFilterParams(defaultValue);
    }
    console.log(basesSelecionadas);

    setFilterParams({
      bases: basesSelecionadas
    });
  }

  useEffect(() => {
    if (accessLevel?.length === 0 || basesDisponiveis?.length === 0) {
      buscarNivelAcesso();
      return;
    }
    if (basesSelecionadas?.length > 0) {
      setIsLoading(true);
    }
  }, [accessLevel, acessBase, basesDisponiveis]);

  useEffect(() => {
    if (!filterParams?.bases?.length) return;
    preencherDados();
  }, [filterParams]);

  console.log({ lojasDisponiveis });

  return (
    <>
      <div className="container-app">
        {PermissionsPage("estoqueQualidade") && (
          <Container>
            <div className="container-conteudo" style={{ padding: 20 }}>
              <Box ml={2}>
                <Title title="Qualidade de estoque" />
              </Box>
              <Stack gap={1} direction="column" mx={2}>
                <Box width={"100%"}>
                  <Box pb={1}>
                    <MultiSelectFilterBases
                      basesDisponiveis={basesDisponiveis}
                      basesSelecionadas={basesSelecionadas}
                      onChange={filtrarBases}
                      disabled={isLoading}
                    />
                    <Typography variant="caption" component={"span"}>
                      *Atenção: Quando nenhuma base estiver selecionada, todas as
                      bases serão retornadas.*
                    </Typography>
                  </Box>
                  <Box pb={1}>
                    <Typography
                      textAlign={"initial"}
                      fontWeight={"bold"}
                      component={"span"}
                    >
                      Lojas
                    </Typography>
                    <Select
                      options={lojasDisponiveis.map((loja) => ({
                        label: converterLoja(loja),
                        value: loja,
                      }))}
                      isMulti
                      onChange={filtrarPorLoja}
                      placeholder="Selecione uma loja"
                      styles={colourStyles}
                      isDisabled={isLoading}
                    />
                    <Typography variant="caption" component={"span"}>
                      *Atenção: Quando nenhuma loja estiver selecionada, todas as
                      lojas serão retornadas.*
                    </Typography>
                  </Box>
                  <Box>
                    <ButtonFilter
                      type="button"
                      onClick={() => iniciarFiltro()}
                      disabled={isLoading}
                    >
                      Filtrar
                    </ButtonFilter>
                  </Box>
                </Box>

              </Stack>
              {isLoading ? (
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  height={"70vh"}
                >
                  <LoadingTable isLoading={isLoading} />
                </Box>
              ) : (
                <>
                  {estoqueFormatado?.length ? (
                    <>
                      <Container style={{ marginBottom: 50, marginTop: 50 }}>
                        <Row style={{ marginBottom: 12 }}>
                          <Col xs={12} md={4}>
                            <FormLabel>Agrupamento Interno</FormLabel>
                            <FormSelect
                              value={agrupamento}
                              onChange={(e) => handlerAgrupamento(e.target.value)}
                            >
                              <option value="Grupo">Grupo</option>
                              <option value="Subgrupo">Subgrupo</option>
                              <option value="Categoria">Categoria</option>
                              <option value="Fornecedor">Fornecedor</option>
                            </FormSelect>
                          </Col>
                          <Col xs={12} md={4}>
                            <FormLabel>Tipo de Funil</FormLabel>
                            <FormSelect
                              value={tipoFunil}
                              onChange={(e) => handlerFunil(e.target.value)}
                            >
                              <option value="EstoqueAtual">Estoque Atual</option>
                              <option value="PrecoVenda">Preço Venda</option>
                              <option value="TotalMonetario">Total Monetario</option>
                            </FormSelect>
                          </Col>
                        </Row>
                        <Row className="row-filter-produtos">
                          <Col xs={12}>
                            <CollapseTable
                              rowKey="id"
                              dadosParaTabela={estoqueFormatado}
                              colunas={colunasEstoqueQualidade(
                                estoqueFormatado
                              )}
                              expandRow={expandRow}
                            />
                          </Col>
                          <Col xs={12} lg={6} style={{ marginLeft: 'auto', textAlign: 'right', position: 'relative' }}>
                            <FunnelChart
                              data={[
                                {
                                  color: "#F5C5D5",
                                  nome: estoqueFormatado[0]?.titulo,
                                  value: estoqueFormatado[0][tipoFunil],
                                },
                                {
                                  color: "#F7A5B5",
                                  nome: estoqueFormatado[1]?.titulo,
                                  value: estoqueFormatado[1][tipoFunil],
                                },
                                {
                                  color: "#F88095",
                                  nome: estoqueFormatado[2]?.titulo,
                                  value: estoqueFormatado[2][tipoFunil],
                                },
                                {
                                  color: "#FA5E7A",
                                  nome: estoqueFormatado[3]?.titulo,
                                  value: estoqueFormatado[3][tipoFunil],
                                },
                                {
                                  color: "#FC3E60",
                                  nome: estoqueFormatado[4]?.titulo,
                                  value: estoqueFormatado[4][tipoFunil],
                                },
                                {
                                  color: "#FF1E47",
                                  nome: estoqueFormatado[5]?.titulo,
                                  value: estoqueFormatado[5][tipoFunil],
                                },
                              ]}
                            />
                          </Col>
                        </Row>
                      </Container>
                    </>
                  ) : (
                    <ContainerIniciarBusca>
                      Escolha os filtros e clique em "Filtrar"
                    </ContainerIniciarBusca>
                  )}
                </>
              )}
            </div>
          </Container>
        )}
      </div>
    </>
  );
}
